module.exports = __webpack_public_path__ + "img/identify01.35b92a8c.png";